import Echo from 'laravel-echo';
import { useCallback } from 'react';
import { IPrivateChannelArgs, useUserPrivateChannel } from './useUserPrivateChannel.ts';
import { IReminderDto } from '../../response/account/getMeResponse.ts';
import { accountRemindersActions } from '../../components/account/reminder/accountRemindersSlice.ts';
import { useReminder } from '../useReminder.tsx';
import { IReminderEventDto, mapIReminderEventDtoToModel } from '../../interfaces/account/reminder/IReminderEvent.ts';

interface IProps {
    echo: Echo<'pusher'> | null;
}

export const useAccountRemindersListener = ({ echo }: IProps) => {
    const { addReminder } = useReminder();
    const registerNotifications = useCallback(({ privateChannel, dispatch }: IPrivateChannelArgs) => {
        console.log('Rejestracja listenerów dla kanału:', privateChannel);
        privateChannel?.listen('.reminder.added', (data: { reminder: IReminderDto }) => {
            dispatch(accountRemindersActions.add(data.reminder));
        });
        privateChannel?.listen('.reminder.deleted', (data: { id: string }) => {
            dispatch(accountRemindersActions.delete(data.id));
        });
        privateChannel?.listen('.reminder.triggered', (data: { reminder: IReminderEventDto }) => {
            addReminder(mapIReminderEventDtoToModel(data.reminder));
        });
    }, []);

    useUserPrivateChannel({ echo, registerListeners: registerNotifications });
};